//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { faPrint } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'PrintButton',
  props: {
    printAreaId: {
      type: String,
      required: true,
    },
    btnClass: {
      type: String,
      default: 'btn-simple-secondary',
    },
  },
  data() {
    return {
      faPrint,
    };
  },
  /*
  DO NOT DELETE
  Disable ?print=friendly
  computed: {
    printFriendly() {
      return _.get(this.$route.query, 'print', '') === 'friendly';
    },
  },
  async mounted() {
    if (this.printFriendly) {
      await this.$htmlToPaper(this.printAreaId);
    }
  },
   */
  computed: {
    ...mapGetters({
      currentLanguage: 'user/languageCode',
    }),
    printStyles() {
      console.log(this.currentLanguage);
      if (!['ja', 'ko', 'zh-hant'].includes(this.currentLanguage)) {
        return 'https://static.moele.me/css/print.210611a.css';
      }
      return `https://moele.me/css/print-${this.currentLanguage}.210611.css`;
    },
  },
  methods: {
    async print() {
      // if (this.printFriendly) {
      //   await this.$htmlToPaper(this.printAreaId);
      // } else {

      // this.$router.push({ path: this.$route.path, query: { print: 'friendly' } });
      await this.$htmlToPaper(this.printAreaId, {
        styles: [
          // 'https://static.moele.me/css/print.210611a.css',
          this.printStyles,
        ],
      });
      // }
    },
  },
};
